import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';

const formatTimestamp = (createdAt) => {
  if (!createdAt) return '';
  const date = new Date(createdAt);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

const Message = ({ message }) => {
  const { role, content, createdAt } = message;
  const isUser = role === 'user';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        mb: 1.5,
        px: 1,
      }}
    >
      <Box sx={{ maxWidth: '80%' }}>
        <Paper
          elevation={1}
          sx={{
            px: 2,
            py: 1.5,
            borderRadius: 2.5,
            backgroundColor: isUser ? 'primary.main' : 'action.hover',
            color: isUser ? 'primary.contrastText' : 'text.primary',
            ...(isUser
              ? { borderBottomRightRadius: 4 }
              : { borderBottomLeftRadius: 4 }),
          }}
        >
          {isUser ? (
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {content}
            </Typography>
          ) : (
            <Box sx={{
              '& p': { m: 0, mb: 1, '&:last-child': { mb: 0 } },
              '& h1, & h2, & h3, & h4': { mt: 1.5, mb: 0.5, fontWeight: 'bold' },
              '& h3': { fontSize: '1rem' },
              '& h4': { fontSize: '0.9rem' },
              '& ul, & ol': { pl: 2.5, my: 0.5 },
              '& li': { mb: 0.3 },
              '& strong': { fontWeight: 700 },
              '& code': { backgroundColor: 'rgba(0,0,0,0.08)', px: 0.5, borderRadius: 0.5, fontSize: '0.85em' },
              '& hr': { my: 1.5, border: 'none', borderTop: '1px solid', borderColor: 'divider' },
              fontSize: '0.875rem',
              lineHeight: 1.6,
              wordBreak: 'break-word',
            }}>
              <ReactMarkdown>{content}</ReactMarkdown>
            </Box>
          )}
        </Paper>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            mt: 0.5,
            px: 0.5,
            color: 'text.secondary',
            textAlign: isUser ? 'right' : 'left',
          }}
        >
          {formatTimestamp(createdAt)}
        </Typography>
      </Box>
    </Box>
  );
};

export default Message;
